import { render } from "./AddressEdit.vue?vue&type=template&id=4c79642b&bindings={\"onSave\":\"setup\",\"onDelete\":\"setup\"}"
import script from "./AddressEdit.vue?vue&type=script&lang=js"
export * from "./AddressEdit.vue?vue&type=script&lang=js"

import "./AddressEdit.vue?vue&type=style&index=0&lang=less"
script.render = render

export default script